import { Box } from "@mui/material";
import { ToastContainer, ToastContainerProps } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { CloseIcon } from "../Icons/CloseIcon";

function CloseButton() {
    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            <CloseIcon />
        </Box>
    );
}

export const toastifyConfig: ToastContainerProps = {
    theme: "colored",
    closeButton: <CloseButton />,
    style: {
        // "--toastify-text-color-dark": theme.palette.success.contrastText,
        "--toastify-color-error": "var(--navette-palette-error-main)",
        "--toastify-text-color-error": "var(--navette-palette-common-white)",
        "--toastify-color-success": "var(--navette-palette-success-main)",
        "--toastify-text-color-success": "var(--navette-palette-common-white)",
    } as React.CSSProperties,
};

export function ToastRenderer() {
    return <ToastContainer {...toastifyConfig} />;
}
